export default {
    data() {
        return {
            currentPath: null,
            blockCount: 0 // Track number of history entries we've added
        };
    },

    async beforeRouteLeave(to, from, next) {
        await this.beforeCheckDirtyFormHook(); // Hook for custom code
        // If the form is dirty and the user did not confirm leave,
        // prevent losing unsaved changes by canceling navigation
        if (this.confirmStayInDirtyForm()) {
            next(false);
        } else {
            // Navigate to next view
            next();
        }
    },
    created() {
        window.addEventListener("beforeunload", this.beforeWindowUnload);
        window.addEventListener("popstate", this.handlePopState);

        // Add initial state to block back navigation
        this.currentPath = window.location.href;
        if (this.form_dirty) {
            this.blockBackNavigation();
        }
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeWindowUnload);
        window.removeEventListener("popstate", this.handlePopState);

        // Clean up added history entries
        while (this.blockCount > 0) {
            window.history.forward();
            this.blockCount--;
        }
    },
    watch: {
        form_dirty(newVal) {
            if (newVal) {
                this.blockBackNavigation();
            }
        }
    },
    methods: {
        beforeCheckDirtyFormHook() {
            // Placeholder for custom component-specific code
            // Currently soap been used this function to delay the redirect
        },
        confirmLeave() {
            return window.confirm(
                "Do you really want to leave? Any unsaved changes will be lost."
            );
        },

        confirmStayInDirtyForm() {
            return this.form_dirty && !this.confirmLeave();
        },

        beforeWindowUnload(e) {
            if (this.confirmStayInDirtyForm()) {
                // Cancel the event
                e.preventDefault();
                // Chrome requires returnValue to be set
                e.returnValue = "";
            }
        },

        // Add new method to handle back button
        blockBackNavigation() {
            window.history.pushState(null, "", this.currentPath);
            this.blockCount++;
        },

        handlePopState(event) {
            if (this.form_dirty) {
                event.preventDefault();
                this.blockBackNavigation();

                if (typeof this._message === "function") {
                    this._message(
                        "Please wait until payment processing is complete",
                        "warning"
                    );
                }
            }
        }
    }
};
